import { defineStore } from "pinia";
import { ref , reactive } from 'vue';

export const useContextStore = defineStore(
    'contextStore' ,
    () => {

        const data = reactive( context ?? {} );
        const errors = reactive(
            {
                basket : null
            }
        );

        function pushEvent( event_name ){
            window.dataLayer = window.dataLayer || [];
            dataLayer.push( { event : event_name } );
        }

        async function queryBasket(){

            try{
                let response = await fetch(
                    '/api/basket/get' ,
                    {
                        headers : data?.header
                    }
                );
                let json = await response.json();

                if( json.error ){
                    console.log( json.error );
                }else if( json.basket ){
                    data.basket = json.basket;
                }

                if( json.messages ){
                    data.basket_messages = json.messages;
                }

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function incItemBasket( model_size_id ){

            if( !model_size_id ){
                return;
            }

            try{
                let response = await fetch(
                    '/api/basket/inc/' + model_size_id ,
                    {
                        headers : data?.header
                    }
                );
                let json = await response.json();

                if( json.error ){
                    if(
                        data.basket?.items
                        && Array.isArray( data.basket.items )
                    ){
                        data.basket.items.map(
                            ( el ) => el.error = el.item_id === model_size_id ? json.error : ''
                        );
                    }
                }else{
                    pushEvent( 'add_to_cart' );
                    if( json.basket ){
                        data.basket = json.basket;
                    }
                }

                return json;

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function decItemBasket( model_size_id ){

            if( !model_size_id ){
                return;
            }

            try{
                let response = await fetch(
                    '/api/basket/dec/' + model_size_id ,
                    {
                        headers : data?.header
                    }
                );
                let json = await response.json();

                if( json.error ){
                    console.log( json.error );
                }else if( json.basket ){
                    data.basket = json.basket;
                }

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function delItemBasket( model_size_id ){

            if( !model_size_id ){
                return;
            }

            try{
                let response = await fetch(
                    '/api/basket/del/' + model_size_id ,
                    {
                        headers : data?.header
                    }
                );
                let json = await response.json();

                if( json.error ){
                    console.log( json.error );
                }else if( json.basket ){
                    data.basket = json.basket;
                }
            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        function inBasket( model_size_id ){

            if( !data?.basket?.items ){
                return null;
            }

            let el = data.basket.items.find(
                item => item.item_id === model_size_id
            );

            return el ? el : null;
        }

        function getBasket(){
            return data?.basket ? data.basket : { items : [] , count : 0 };
        }
        function getBasketMessages(){
            return data?.basket_messages ? data.basket_messages : [];
        }

        function getBasketTotalDiscount(){
            let amount_max = getBasket().items.reduce( ( sum , item ) => item.count * ( item.amount_max ? item.amount_max : item.amount ) + sum , 0 );
            let amount_final = getBasket()?.amount_final;
            let diff = amount_max - amount_final;
            if( diff < 0 ){
                diff = 0;
            }
            return diff;
        }

        function getBasketTotalAmount(){
            return getBasket()?.amount_final;
        }

        function getBasketPromoAmount(){
            return getBasket()?.amount_discount;
        }

        function getBasketCurrencySymbol(){
            return getBasket().items[ 0 ] ? getBasket().items[ 0 ].price.symbol : '';
        }

        function getBasketTotalCount(){
            return getBasket().items.reduce( ( sum , item ) => ( item.is_deleted ? 0 : item.count ) + sum , 0 )
        }

        async function applyPromoCode( promo ){

            errors.basket = null;

            if( !promo ){
                return;
            }

            try{
                let response = await fetch(
                    '/api/basket/set-promo/' + promo ,
                    {
                        headers : data?.header
                    }
                );
                let json = await response.json();

                if( json.error ){
                    errors.basket = json.error;
                    console.log( json.error );
                }else if( json.basket ){
                    data.basket = json.basket;
                }
            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function clearPromoCode(){

            try{
                let response = await fetch(
                    '/api/basket/clear-promo' ,
                    {
                        headers : data?.header
                    }
                );
                let json = await response.json();

                if( json.error ){
                    console.log( json.error );
                }else if( json.basket ){
                    data.basket = json.basket;
                }
            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function confirmAuth( phone ){

            if( !phone ){
                return;
            }

            try{
                let response = await fetch(
                    '/api/auth/confirm' ,
                    {
                        method : 'POST' ,
                        headers : data?.header ,
                        body : JSON.stringify(
                            {
                                recipient : phone
                            }
                        )
                    }
                );

                return await response.json();

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function sendAuth( login , code , name ){
            if(
                !login
                || !code
            ){
                return;
            }

            try{
                let response = await fetch(
                    '/api/auth/login' ,
                    {
                        method : 'POST' ,
                        headers : data?.header ,
                        body : JSON.stringify(
                            {
                                login : login ,
                                code : code ,
                                name : name
                            }
                        )
                    }
                );

                let json = await response.json();

                if( 'user' in json ){
                    data[ 'user' ] = json.user;
                }

                return json;

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function sendOrder( order ){
            try{
                let response = await fetch(
                    '/api/order/create' ,
                    {
                        method : 'POST' ,
                        headers : data?.header ,
                        body : JSON.stringify( order )
                    }
                );

                return await response.json();

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        function getUser(){
            return data?.user;
        }

        async function unlogin(){
            try{
                data[ 'user' ] = null;
                await fetch(
                    '/api/auth/unlogin' ,
                    {
                        headers : data?.header ,
                    }
                );
            }catch( e ){
                console.log( e.name + ":" + e.message );
            }
        }

        async function getShops(){

            if( data?.cities?.length && data?.shops?.length ){
                return {
                    shops : data.shops ,
                    cities : data.cities
                };
            }

            data.cities = [];
            data.shops = [];

            try{
                let response = await fetch( '/api/shop/all' );
                let temp = await response.json();

                data.cities = 'city' in temp ? temp.city : [];
                data.shops = 'shop' in temp ? temp.shop : [];

                return {
                    shops : data.shops ,
                    cities : data.cities
                }

            }catch( e ){
                console.log( e.name + ":" + e.message );
            }

            return {
                shops : [] ,
                cities : []
            }
        }

        return {
            data ,
            queryBasket,
            incItemBasket ,
            decItemBasket ,
            delItemBasket ,
            getBasket ,
            getBasketMessages,
            getBasketTotalAmount ,
            getBasketPromoAmount ,
            getBasketTotalCount ,
            getBasketTotalDiscount ,

            getBasketCurrencySymbol ,
            inBasket ,

            applyPromoCode ,
            clearPromoCode ,

            confirmAuth ,
            sendAuth ,
            getUser ,
            unlogin ,

            sendOrder ,

            getShops ,
            errors
        }
    }
);
